define('presentation/accountManager/viewModels/accountManagerViewModel',[
    'common/collections/enumerationKeyValueConverter',
    'common/converters/phoneNumberFormatter',
    'common/converters/userFormatter',
    'common/promises/promiseFactory',
    'i18next',
    'presentation/common/window/windowControl',
    'presentation/accountManager/facades/accountManagerFacade',
    'settings/navigationConfiguration',
    'settings/uiAnimationsConfiguration'
], function (
    /** @type import('common/collections/enumerationKeyValueConverter') */
    _keyValueConverter,
    /** @type typeof import('common/converters/phoneNumberFormatter') */
    PhoneNumberFormatter,
    /** @type typeof import('common/converters/userFormatter') */
    UserFormatter,
    /** @type typeof import('common/promises/promiseFactory') */
    PromiseFactory,
    /** @type typeof import('i18next') */
    i18n,
    /** @type import('presentation/common/window/windowControl') */
    windowControl,
    /** @type typeof import('presentation/accountManager/facades/accountManagerFacade') */
    AccountManagerFacade,
    /** @type typeof import('settings/navigationConfiguration') */
    navigationConfiguration,
    /** @type import('settings/uiAnimationsConfiguration') */
    UIAnimationsConfig
) {
    return function () {
        const self = this;

        const _phoneNumberFormatter = new PhoneNumberFormatter();
        const _promiseFactory = new PromiseFactory();
        const _userFormatter = new UserFormatter();

        let _facade = null;
        let _hideAccountManagerCardTimeout = null;

        self.isAccountManagerCardOpen = ko.observable(false);
        self.avatarUrl = ko.observable('');
        self.firstName = ko.observable('');
        self.lastName = ko.observable('');
        self.displayName = ko.observable('');
        self.initials = ko.observable('');
        self.title = ko.observable(i18n.t('accountManager:title'));
        self.phoneNumber = ko.observable('');
        self.displayPhoneNumber = ko.observable('');
        self.email = ko.observable('');

        self.accountManagerCardOptions = ko.computed(() => {
            const options = [
                {textI18n: 'accountManager:helpCenter', iconName: 'helpCenter', onClick: () => self.openHelpCenter(), showSeparator: false},
                {textI18n: 'accountManager:faqs', iconName: 'help', onClick: () => self.openFAQs(), showSeparator: false},
            ];

            return options;
        });

        self.hideAccountManagerCard = () => {
            _hideAccountManagerCardTimeout = setTimeout(() => {
                self.isAccountManagerCardOpen(false);
            }, UIAnimationsConfig.presentation_accountManager_viewModels_accountManagerViewModel_hideAccountManagerCard);
        };

        self.onCallClicked = () => {
            const phoneNumberFormatted = "tel:" + self.phoneNumber();
            windowControl.openNewWindow(phoneNumberFormatted);
        };

        self.onChatClicked = () => {
            /* jshint ignore:start */
            Genesys('command', 'Messenger.open', {});
            /* jshint ignore:end */
        };

        self.onEmailClicked = () => {
            const emailFormatted = "mailto:" + self.email();
            windowControl.openNewWindow(emailFormatted);
        };

        self.openHelpCenter = () => {
            windowControl.openNewWindow(navigationConfiguration.routesById.helpCenter.externalUrl);
        };

        self.openFAQs = () => {
            windowControl.openFAQPage();
        };

        self.toggleAccountManagerCard = () => {
            self.isAccountManagerCardOpen(!self.isAccountManagerCardOpen());
        };

        self.activate = () => {
            _facade = new AccountManagerFacade();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {

            _facade.getAccountManager()
                .done((accountManager) => {
                    if (accountManager){
                        self.firstName(accountManager.firstName);
                        self.lastName(accountManager.lastName);
                        self.displayName(_userFormatter.formatUserFullName(accountManager.firstName, accountManager.lastName));
                        self.initials(_userFormatter.formatUserInitials(accountManager.firstName, accountManager.lastName));
                        self.phoneNumber(accountManager.phoneNumber);
                        self.displayPhoneNumber(_phoneNumberFormatter.toUSAreaCode(accountManager.phoneNumber));
                        self.email(accountManager.email);
                    }
                });
            return _promiseFactory.wait();
        };
    };
});

